export default __webpack_public_path__ + "static/media/figma.cc8e1116.svg";